import { PostItem } from "./PostItem";

interface Post {
  id: string;
  title: string;
  content: string;
  image_url?: string;
}

interface PostsListProps {
  posts: Post[];
  onEdit: (post: Post) => void;
  onDelete: (id: string) => void;
}

export const PostsList = ({ posts, onEdit, onDelete }: PostsListProps) => {
  return (
    <div className="space-y-4">
      {posts?.map((post) => (
        <PostItem
          key={post.id}
          post={post}
          onEdit={onEdit}
          onDelete={onDelete}
        />
      ))}
    </div>
  );
};